export default __webpack_public_path__ + "static/media/polygon-add-active.ab371947.svg";